export default {
  WORKLOAD_EDIT: "WORKLOAD_EDIT",
  WORKLOAD_EDIT_ALL: "WORKLOAD_EDIT_ALL",
  WORKOUT_UNIT: "WORKOUT_UNIT",
  /** Причины отклонений и целевые нормы юнит-экономики */
  WORKOUT_UNIT_EDIT: "WORKOUT_UNIT_EDIT",
  TIMESHEET_EDIT: "TIMESHEET_EDIT",
  TIMESHEET_EDIT_DEPARTMENT: "TIMESHEET_EDIT_DEPARTMENT",
  TIMESHEET_EDIT_USER: "TIMESHEET_EDIT_USER",
  /** Изменение своего табеля за прошлые дни без ограничения окна (сервер: `SaveTimesheetCommandValidator`) */
  TIMESHEET_EDIT_PAST: "TIMESHEET_EDIT_PAST",

  TIMESHEET_EXPORT: "TIMESHEET_EXPORT",
  TIMESHEET_COMMENTS: "TIMESHEET_COMMENTS",

  SCHEDULE_EDIT: "SCHEDULE_EDIT",
  SCHEDULE_READ: "SCHEDULE_READ",
  SCHEDULE_EXPORT: "SCHEDULE_EXPORT",

  DEPARTMENT_READ: "DICTIONARY_DEPARTMENT_READ",
  DEPARTMENT_EDIT: "DICTIONARY_DEPARTMENT_EDIT",

  EMPLOYER_READ: "DICTIONARY_EMPLOYER_READ",
  EMPLOYER_EDIT: "DICTIONARY_EMPLOYER_EDIT",

  ONEC_IMPORT: "ONEC_IMPORT",

  REPORTS_READ: "REPORTS_READ",
};
